import { BlogPostsList, BlogPostsListData } from "../shared";

export interface BlogIndexSectionData {
  posts: {
    id: string;
    title: string;
    slug: string;
    content: string;
    published_at: string;
    author: {
      slug: string;
      title: string;
    };
    featured_image?: {
      id: string;
      filename_disk: string;
      filename_download: string;
    };
  }[];
  total: number;
  totalPages: number;
  currentPage: number;
  categories: {
    id: string;
    slug: string;
    title: string;
  }[];
  archives: {
    date: string;
    count: number;
  }[];
  left_column_data?: any;
}

interface BlogIndexSectionProps {
  data: BlogIndexSectionData;
}

export default function BlogIndexSection({ data }: BlogIndexSectionProps) {
  // Transform data to match BlogPostsList interface
  const blogPostsListData: BlogPostsListData = {
    posts: data.posts.map((post) => ({
      ...post,
      featured_image: post.featured_image
        ? {
            id: post.featured_image.id,
            filename_disk: post.featured_image.filename_disk,
            filename_download: post.featured_image.filename_download,
          }
        : undefined,
    })),
    total: data.total,
    totalPages: data.totalPages,
    currentPage: data.currentPage,
    categories: data.categories,
    archives: data.archives,
    left_column_data: data.left_column_data,
  };

  const paginationBaseUrl = `/${process.env.NEXT_PUBLIC_BLOG_SLUG}`;

  return (
    <BlogPostsList
      data={blogPostsListData}
      paginationBaseUrl={paginationBaseUrl}
      showEmptyState={false}
    />
  );
}
